class Notification extends HTMLElement {
  constructor() {
    super();
    this.btnClose = null;
    this.params_check = ["comment", "form_type", "utf8"];
  }
  connectedCallback() {
    this.btnClose = this.querySelector(".notification-btn");
    if (!this.btnClose) return;
    this.btnClose.addEventListener("click", () => {
      this.remove();
      this.deleteQueryParamPosted();
    });
  }
  deleteQueryParamPosted() {
    const url = new URL(window.location.href);
    let changed = false;
    Array.from(url.searchParams.keys()).forEach((key) => {
      if (key.endsWith("_posted") || this.params_check.includes(key)) {
        url.searchParams.delete(key);
        changed = true;
      }
    });
    if (!changed) return;
    const newUrl = url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : "") + url.hash;
    window.history.replaceState({}, "", newUrl);
  }
}
if (!customElements.get("notification-component")) {
  customElements.define("notification-component", Notification);
}
